import axios from 'axios';
import { Component } from 'react';
import Cookies from 'universal-cookie';
import { loginRequest, msalInstance, msalConfig } from '../authConfig';
import { useToast } from "izitoast-react";
import "izitoast-react/dist/iziToast.css";
import { UseAlert, UseAlertMessageLogin } from '../components/Alert';


var cookies = new Cookies();
var access_token = ''
function getTranslationByKey(key) {
    let translation = ''
    let translation_en = ''
    if (sessionStorage.getItem('translation')) {
        translation = JSON.parse(sessionStorage.getItem('translation'))
        translation_en = JSON.parse(sessionStorage.getItem('translation_en'))
        return translation[key] && translation[key].v ? translation[key].v : (translation_en[key] && translation_en[key].v ? translation_en[key].v : key)
    }
}

function getApiUrl() {

    if (window.location.hostname === 'changemakerschallenge.gucci.cn') {
        return "https://smartoffice-api.gucci.cn/api"
    }
    else if (window.location.hostname === 'changemakerschallenge.gucci.com')
        return "https://smartoffice.globalbit.gucci/api"
    else {
        return "https://smartoffice.globalbit.gucci/staging_api"
    }
}
const getToken = () => {
    /* * /
    return new Promise(function (resolve, reject) {
        msalInstance.acquireTokenSilent({
            ...loginRequest,
            ...msalConfig.auth.authority,
            account: msalInstance.getAllAccounts()[0]
        }).then((response) => {
            cookies.set('user_token', response.idToken, { path: '/', maxAge: 31536000 });
            access_token = response.accessToken
            resolve(response.idToken);
        }).catch(function (error) {
            resolve(cookies.get("user_token"));
        });
    })
    /* */
    if (localStorage.getItem('okta-token-storage') && JSON.parse(localStorage.getItem('okta-token-storage')).accessToken && JSON.parse(localStorage.getItem('okta-token-storage')).accessToken.accessToken)
        return JSON.parse(localStorage.getItem('okta-token-storage')).accessToken.accessToken
    else
        return ''
}

const getAccessToken = () => {
    /** /
    return new Promise(function (resolve, reject) {
        msalInstance.acquireTokenSilent({
            ...loginRequest,
            ...msalConfig.auth.authority,
            account: msalInstance.getAllAccounts()[0]
        }).then((response) => {
            resolve(response.accessToken);
        }).catch(function (error) {
            resolve(cookies.get("access_token"));
        });
    })
    /* */

    if (localStorage.getItem('okta-token-storage') && JSON.parse(localStorage.getItem('okta-token-storage')).accessToken && JSON.parse(localStorage.getItem('okta-token-storage')).accessToken.accessToken)
        return JSON.parse(localStorage.getItem('okta-token-storage')).accessToken.accessToken
    else
        return ''
}

export class SolidarityChallengeService extends Component {



    //get user info

    async getUserInfo() {
        return new Promise(async (resolve, reject) => {
            //axios.defaults.headers.common['Authorization'] = await getToken();
            axios.defaults.headers.common['Authorization'] = await getToken();
            axios.defaults.headers.common['Language'] = localStorage.getItem('language') ? localStorage.getItem('language') : 'en';
            //axios.get(getApiUrl() + '/v3/user').then(function (response) {

            axios.get(getApiUrl() + '/changemakers/user').then(async (response) => {
                // axios.defaults.headers.common['Authorization'] = 'Bearer ' + await getAccessToken()
                // axios.get('https://graph.microsoft.com/v1.0/users/' + response.data.email + '/photo/$value', { responseType: 'blob' }).then((res) => {
                //     //console.log(res.data.toString('base64'))
                //     var reader = new FileReader();
                //     reader.readAsDataURL(res.data);
                //     var i = ''
                //     reader.onloadend = function () {
                //         var base64data = reader.result;
                //         i = base64data
                //         response.data.image_url = i
                //     }
                // }).catch(function (error) {
                //     console.log(error)
                //     reject(error)
                // });
                setTimeout(() => {
                    resolve(response.data)
                }, 500)
            }).catch(function (error) {
                console.log(error)
                if (error.response.status == 401) {
                    UseAlert(401)
                }
                reject(error)
            })
        })
    }


    async getUserImage(email) {
        return new Promise(async (resolve, reject) => {
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + await getAccessToken()
            axios.get(getApiUrl() + '/user/profile-image/' + email + '/value', { responseType: 'blob' }).then((res) => {
                //console.log(res.data.toString('base64'))
                var reader = new FileReader();
                reader.readAsDataURL(res.data);
                var i = ''
                reader.onloadend = function () {
                    var base64data = reader.result;
                    i = base64data
                    resolve(i)
                }
            }).catch(function (error) {
                console.log(error)
                reject(error)
            });

        })
    }

    //get user image
    /* async getUserImage(email) {
         //axios.defaults.headers.common['Authorization'] = await getToken();
         axios.defaults.headers.common['Authorization'] = 'Bearer eyJ0eXAiOiJKV1QiLCJub25jZSI6IkV0SktYWGRILUg4T2VTTV9hTDhFMllvNmNvRE1neWxBdEZKb1J3Xzhnck0iLCJhbGciOiJSUzI1NiIsIng1dCI6IjJaUXBKM1VwYmpBWVhZR2FYRUpsOGxWMFRPSSIsImtpZCI6IjJaUXBKM1VwYmpBWVhZR2FYRUpsOGxWMFRPSSJ9.eyJhdWQiOiIwMDAwMDAwMy0wMDAwLTAwMDAtYzAwMC0wMDAwMDAwMDAwMDAiLCJpc3MiOiJodHRwczovL3N0cy53aW5kb3dzLm5ldC8yZmYwNmEwMy0xYzI0LTQwZjUtOWQzYi04NTRkOTNhYWVkN2YvIiwiaWF0IjoxNjY3NTY4MzMwLCJuYmYiOjE2Njc1NjgzMzAsImV4cCI6MTY2NzU3MjQyOSwiYWNjdCI6MCwiYWNyIjoiMSIsImFpbyI6IkFUUUF5LzhUQUFBQWdYYUVoM0dhK2hqUmdzUS92MDRUWGx4K1hrMXBGMTlRcm8raHpwZVNNOFplVm4zRW5KY0JxYnc2elBHRUYwOXIiLCJhbXIiOlsicHdkIl0sImFwcF9kaXNwbGF5bmFtZSI6IjAwNjYzLU9JREMtU21hcnRPZmZpY2UiLCJhcHBpZCI6IjdlNTZhNjVhLTE4YzItNGQ3NC04NDRmLTdkMTNhYTMyOGY1YyIsImFwcGlkYWNyIjoiMCIsImZhbWlseV9uYW1lIjoiTXV0byIsImdpdmVuX25hbWUiOiJNYXJ0aW5hIiwiaWR0eXAiOiJ1c2VyIiwiaXBhZGRyIjoiMTUxLjcyLjE3Ny4yNDAiLCJuYW1lIjoiTVVUTyBNYXJ0aW5hIChFeHRlcm5hbCkiLCJvaWQiOiI1MzQ2OTNiNy1mYjYwLTQzNjQtOGZhYi1iNWFjZDc0OTE0NmUiLCJvbnByZW1fc2lkIjoiUy0xLTUtMjEtMjYwNzU1MjQ3LTM4NTMxNDkzOTYtMTA3NzY3OTEzOS0zOTkwNTMiLCJwbGF0ZiI6IjMiLCJwdWlkIjoiMTAwMzIwMDE4OEQwQzY5OSIsInJoIjoiMC5BVjhBQTJyd0x5UWM5VUNkTzRWTms2cnRmd01BQUFBQUFBQUF3QUFBQUFBQUFBQmZBQXcuIiwic2NwIjoiZW1haWwgTWFpbC5TZW5kIG9wZW5pZCBwcm9maWxlIFVzZXIuUmVhZCBVc2VyLlJlYWQuQWxsIiwic3ViIjoiM0U3X2k1SDhPNzljdTEwdXRTQkFsdDdMYVRVUmlmN19XMUIwb2RwdGdvVSIsInRlbmFudF9yZWdpb25fc2NvcGUiOiJFVSIsInRpZCI6IjJmZjA2YTAzLTFjMjQtNDBmNS05ZDNiLTg1NGQ5M2FhZWQ3ZiIsInVuaXF1ZV9uYW1lIjoibWFydGluYS5tdXRvLWV4dEBndWNjaS5jb20iLCJ1cG4iOiJtYXJ0aW5hLm11dG8tZXh0QGd1Y2NpLmNvbSIsInV0aSI6Ild0SEZCVmRJa1VTWDJyNWNMV2dSQUEiLCJ2ZXIiOiIxLjAiLCJ3aWRzIjpbImI3OWZiZjRkLTNlZjktNDY4OS04MTQzLTc2YjE5NGU4NTUwOSJdLCJ4bXNfc3QiOnsic3ViIjoiNzZJdEZqYXJLOXdVNHpWbndUbUctSGhEOGpEdDJqLUhDRllJQmpndnFvQSJ9LCJ4bXNfdGNkdCI6MTQxOTg0NzY2MCwieG1zX3RkYnIiOiJFVSJ9.abyxl7_pQ8xe0i5-NYxzshWftBAXO11lqSxAxtkQIbpwYj4tHeyPXaFVZ2iRRqBbygHHgPrBXJBhkm-56_ztM6M7hjPgbkZY8sZ3MuHGm5KbKxZ_4oXfoObrSe3KwkdFCa58hIFOk63g35deaZR6w_yRK_yqZp9PF08kq58YJicE0sgKv-FrAqJRWVNMt09EAK5cFb3pOWekTqw0Yg-p91gTeeOLcaMxQrHLp1JOu-YUXLxdauaT1cHjFX3vQAl6v33nnwu8o_6snCDxNYcrw-XC9y0fOnh6K2xhm6wdq4-ZCg51KIP4ye7Hi3elpQzlHrWvrRIYayU_JVCekzyttA'
         axios.defaults.headers.common['Language'] = localStorage.getItem('language') ? localStorage.getItem('language') : 'en';
         //axios.get(getApiUrl() + '/v3/user').then(function (response) {


         axios.get('https://graph.microsoft.com/v1.0/users/stefano.nicolo@gucci.com/photo/$value', { responseType: 'blob' }).then((response) => {
             // console.log(response.data.toString('base64'))
             var reader = new FileReader();
             reader.readAsDataURL(response.data);
             var i = ''
             reader.onloadend = function () {
                 var base64data = reader.result;
                 //   console.log(base64data)
                 i = base64data
                 return base64data
             }
             setTimeout(() => {
                 //  setImg(i)
                 console.log(i)
                 return i
             }, 1000);
         }).catch(function (error) {
             console.log(error)
             return ''
         });

     }*/
    async getChallengeInfo(challenge_id) {
        return new Promise(async (resolve, reject) => {
            //axios.defaults.headers.common['Authorization'] = await getToken();
            axios.defaults.headers.common['Authorization'] = await getToken();
            axios.defaults.headers.common['Language'] = localStorage.getItem('language') ? localStorage.getItem('language') : 'en';
            //axios.get(getApiUrl() + '/v3/user').then(function (response) {
            axios.get(getApiUrl() + '/solidarity_challenge/challenge/' + challenge_id).then((response) => {
                resolve(response.data)
            }).catch(function (error) {
                if (error.response.status == 401) {
                    UseAlert(401)
                }
                reject(error);
            });
        });
    }
    async getChallengeLeaderboard(challenge_id, filters) {
        return new Promise(async (resolve, reject) => {
            axios.defaults.headers.common['Authorization'] = await getToken();
            axios.defaults.headers.common['Language'] = localStorage.getItem('language') ? localStorage.getItem('language') : 'en';

            axios.post(getApiUrl() + '/solidarity_challenge/challenge/' + challenge_id + '/leaderboard', filters).then(function (response, index) {
                response.data.map(async (u, i) => {
                    if (i < 10) {
                        axios.defaults.headers.common['Authorization'] = 'Bearer ' + await getAccessToken()
                        axios.get(getApiUrl() + '/user/profile-image/' + u.user.email + '/value', { responseType: 'blob' }).then((response) => {
                            var reader = new FileReader();
                            reader.readAsDataURL(response.data);
                            var i = ''
                            reader.onloadend = function () {
                                var base64data = reader.result;
                                i = base64data
                                u.user.image_url = i
                            }

                        }).catch(function (error) {
                            //console.log(error)
                            return ''
                        });
                    }
                })

                setTimeout(() => {
                    resolve(response.data)
                }, 1000)

            }).catch(function (error) {
                if (error.response.status == 401) {
                    UseAlert(401)
                }
                reject(error);
            });
        })
    }

    async getMyPosition(challenge_id, filters) {
        return new Promise(async (resolve, reject) => {
            axios.defaults.headers.common['Authorization'] = await getToken();
            axios.defaults.headers.common['Language'] = localStorage.getItem('language') ? localStorage.getItem('language') : 'en';

            axios.post(getApiUrl() + '/solidarity_challenge/challenge/' + challenge_id + '/myposition', filters).then((response) => {
                resolve(response.data.position)
            }).catch(function (error) {
                if (error.response.status == 401) {
                    UseAlert(401)
                }
                reject(error);
            });
        });
    }

    /* * /
    async getTranslation() {
        let responseStatusUser = ''
        fetch('https://api.applanga.com/v1/api?app=63a1b6df30ada26bcb258418', { // applanga ufficiale
            method: 'GET',
            headers: {
                //'Authorization': 'Bearer 62cfd857a368cf69e6ec569f!3bf1eded0b76ac95164a30ece8712f7f'  test
                'Authorization': 'Bearer 63a1b6df30ada26bcb258418!38fea01ce6718d950a1ad8b917435e31' //ufficiale
            }
        })
            .then(response => {
                responseStatusUser = response.status
                return response.json()
            })
            .then(res => {
                //let lang = navigator.language.split('-')[0]
                let lang = localStorage.getItem('language') ? localStorage.getItem('language') : 'en'
                sessionStorage.setItem('translations', JSON.stringify(res.data))
                sessionStorage.setItem('translation', JSON.stringify(res.data[lang].main.entries))
                sessionStorage.setItem('translation_en', JSON.stringify(res.data['en'].main.entries))
            })
            .catch(console.log);

    }
    /* */

    async getTranslation() {
        return new Promise(async (resolve, reject) => {
            let responseStatusUser = ''
            fetch(getApiUrl() + '/applanga/cmc', { // applanga ufficiale
                method: 'GET',
                headers: {
                    'Authorization': await getToken(),
                    'Language': navigator.language || navigator.userLanguage
                }
            })
                .then(response => {
                    responseStatusUser = response.status
                    return response.json()
                })
                .then(res => {
                    let lang = localStorage.getItem('language') ? localStorage.getItem('language') : 'en'
                    sessionStorage.setItem('translations', JSON.stringify(res.data))
                    sessionStorage.setItem('translation', JSON.stringify(res.data[lang].main.entries))
                    sessionStorage.setItem('translation_en', JSON.stringify(res.data['en'].main.entries))
                    resolve(res)
                })
                .catch((err) => {
                    console.log(err.message)
                    reject(err)
                })

        })
    }
    /* */

    async getRecentlyJoined(challenge_id, region, setRecentlyJoined, setRecentlyJoinedLoading) {
        return new Promise(async (resolve, reject) => {
            axios.defaults.headers.common['Authorization'] = await getToken();
            axios.defaults.headers.common['Language'] = localStorage.getItem('language') ? localStorage.getItem('language') : 'en';
            //axios.get(getApiUrl() + '/v3/user').then(function (response) {

            let body = {
                "only_region": region
            }

            axios.post(getApiUrl() + '/solidarity_challenge/challenge/' + challenge_id + '/recentlyJoined', body).then(function (response) {

                response.data.map(async (u) => {
                    axios.defaults.headers.common['Authorization'] = 'Bearer ' + await getAccessToken()
                    axios.get('https://graph.microsoft.com/v1.0/users/' + u.email + '/photo/$value', { responseType: 'blob' }).then((response) => {
                        // console.log(response.data.toString('base64'))
                        var reader = new FileReader();
                        reader.readAsDataURL(response.data);
                        var i = ''
                        reader.onloadend = function () {
                            var base64data = reader.result;
                            i = base64data
                            u.image_url = i
                        }
                    }).catch(function (error) {
                        //console.log(error)
                        return ''
                    });
                })
                setTimeout(() => {

                    resolve(response.data)
                }, 1000);
            }).catch(function (error) {
                if (error.response.status == 401) {
                    UseAlert(401)
                }
                reject(error);
            });
        });
    }

    async addActivity(body) {
        return new Promise(async (resolve, reject) => {
            axios.defaults.headers.common['Authorization'] = await getToken();
            axios.defaults.headers.common['Language'] = localStorage.getItem('language') ? localStorage.getItem('language') : 'en';

            axios.post(getApiUrl() + '/solidarity_challenge/activity/add', body).then(function (response) {
                // success
                UseAlertMessageLogin(200, "Activity added successfully!")
                resolve(response.data)
            }).catch(function (error) {
                UseAlertMessageLogin(400, getTranslationByKey(error.message))
                reject(error)
            });
        })
    }

    async deleteActivity(id) {
        return new Promise(async (resolve, reject) => {
            axios.defaults.headers.common['Authorization'] = await getToken();
            axios.defaults.headers.common['Language'] = localStorage.getItem('language') ? localStorage.getItem('language') : 'en';

            axios.delete(getApiUrl() + '/solidarity_challenge/activity/delete/' + id).then(function (response) {
                // success
                UseAlertMessageLogin(response.status, "Activity deleted successfully!")
                resolve(response.data)
            }).catch(function (error) {
                UseAlertMessageLogin(400, getTranslationByKey(error.message))
                reject(error)
            });
        })
    }


    async getMyTeam(challenge_id) {
        return new Promise(async (resolve, reject) => {
            axios.defaults.headers.common['Authorization'] = await getToken();
            axios.defaults.headers.common['Language'] = localStorage.getItem('language') ? localStorage.getItem('language') : 'en';

            axios.get(getApiUrl() + '/solidarity_challenge/challenge/' + challenge_id + '/team/me').then(function (response) {
                response.data.members.map(async (u) => {
                    axios.defaults.headers.common['Authorization'] = 'Bearer ' + await getAccessToken()
                    axios.get('https://graph.microsoft.com/v1.0/users/' + u.email + '/photo/$value', { responseType: 'blob' }).then((response) => {
                        // console.log(response.data.toString('base64'))
                        var reader = new FileReader();
                        reader.readAsDataURL(response.data);
                        var i = ''
                        reader.onloadend = function () {
                            var base64data = reader.result;
                            i = base64data
                            u.image_url = i
                        }
                    }).catch(function (error) {
                        //console.log(error)
                        return ''
                    });
                })
                setTimeout(() => {

                    resolve(response.data)
                }, 1000);
            }).catch(function (error) {
                UseAlertMessageLogin(400, getTranslationByKey(error.message))
                reject(error);
            });
        });
    }

    async getMyTrackings(challenge_id) {
        return new Promise(async (resolve, reject) => {
            axios.defaults.headers.common['Authorization'] = await getToken();
            axios.defaults.headers.common['Language'] = localStorage.getItem('language') ? localStorage.getItem('language') : 'en';

            axios.get(getApiUrl() + '/solidarity_challenge/' + challenge_id + '/myTrackings').then((response) => {
                resolve(response.data)
            }).catch(function (error) {
                UseAlertMessageLogin(400, getTranslationByKey(error.message))
                reject(error);
            });
        });

    }

    async getConversionInfo(challenge_id) {
        return new Promise(async (resolve, reject) => {
            axios.defaults.headers.common['Authorization'] = await getToken();
            axios.defaults.headers.common['Language'] = localStorage.getItem('language') ? localStorage.getItem('language') : 'en';

            axios.get(getApiUrl() + '/solidarity_challenge/' + challenge_id + '/activity/conversion').then((response) => {
                resolve(response.data)
            }).catch(function (error) {
                UseAlertMessageLogin(400, getTranslationByKey(error.message))
                reject(error);
            });
        });

    }

    async getBalance(challenge_id) {
        return new Promise(async (resolve, reject) => {
            axios.defaults.headers.common['Authorization'] = await getToken();
            axios.defaults.headers.common['Language'] = localStorage.getItem('language') ? localStorage.getItem('language') : 'en';

            axios.get(getApiUrl() + '/solidarity_challenge/challenge/' + challenge_id + '/balance').then((response) => {
                resolve(response.data)
            }).catch(function (error) {
                UseAlertMessageLogin(400, getTranslationByKey(error.message))
                reject(error);
            });
        });

    }

    async getMeals(challenge_id, setMeals) {
        axios.defaults.headers.common['Authorization'] = await getToken();
        axios.defaults.headers.common['Language'] = localStorage.getItem('language') ? localStorage.getItem('language') : 'en';

        axios.get(getApiUrl() + '/solidarity_challenge/challenge/' + challenge_id + '/meals').then(function (response) {
            setMeals(response.data)
        }).catch(function (error) {
            UseAlertMessageLogin(400, getTranslationByKey(error.message))
            return error;
        });

    }

    async joinChallenge(challenge_id) {
        return new Promise(async (resolve, reject) => {
            axios.defaults.headers.common['Authorization'] = await getToken();
            axios.defaults.headers.common['Language'] = localStorage.getItem('language') ? localStorage.getItem('language') : 'en';

            axios.put(getApiUrl() + '/solidarity_challenge/challenge/join/' + challenge_id).then(function (response) {
                resolve(response.data)
            }).catch(function (error) {
                UseAlertMessageLogin(400, getTranslationByKey(error.message))
                reject(error);
            });
        });
    }
    async joinToTeam(challenge_id, team_id) {
        return new Promise(async (resolve, reject) => {
            axios.defaults.headers.common['Authorization'] = await getToken();
            axios.defaults.headers.common['Language'] = localStorage.getItem('language') ? localStorage.getItem('language') : 'en';

            axios.put(getApiUrl() + '/solidarity_challenge/challenge/' + challenge_id + '/team/' + team_id + '/join').then((response) => {
                resolve(response)
                UseAlertMessageLogin(200, getTranslationByKey(response.data.message))
            }).catch((error) => {
                UseAlertMessageLogin(400, getTranslationByKey(error.response.data.message))
                console.log(error)
                reject(error)
            });
        });
    }
    async connectToStrava(id) {
        axios.defaults.headers.common['Authorization'] = await getToken();
        axios.defaults.headers.common['Language'] = localStorage.getItem('language') ? localStorage.getItem('language') : 'en';
        axios.get().then(function (response) {
            UseAlertMessageLogin(200, getTranslationByKey('CMC.ALERT.STRAVA'))
        }).catch(function (error) {
            console.log(error)
            UseAlertMessageLogin(500, getTranslationByKey('CMC.ALERT.ERROR'))
            return error;
        });
    }
    async setEntered(setLoading) {
        axios.defaults.headers.common['Authorization'] = await getToken();
        axios.defaults.headers.common['Language'] = localStorage.getItem('language') ? localStorage.getItem('language') : 'en';

        axios.put(getApiUrl() + '/solidarity_challenge/enter').then(function (response) {
            setLoading(false)
        }).catch(function (error) {
            setLoading(false)
            return error;
        });
    }
    async getUrlToShare(body, setImage) {
        axios.defaults.headers.common['Authorization'] = await getToken();
        axios.defaults.headers.common['Language'] = localStorage.getItem('language') ? localStorage.getItem('language') : 'en';

        axios.post(getApiUrl() + '/solidarity_challenge/workplace', body, { responseType: 'blob' }).then(function (response) {
            // console.log(response)


            const type = response.headers['content-type']
            const blob = new Blob([response.data], { type: type })
            const link = document.createElement('a')
            link.href = window.URL.createObjectURL(blob)
            link.download = "image.jpg"
            setImage(link.href)


            //  link.target = 'popup'
            //   window.open('https://kering.workplace.com/sharer.php?display=page&u=' + response.data, 'popUpWindow', 'height=800,width=700,left=150,top=100,resizable=yes,scrollbars=yes,toolbar=yes,menubar=no,location=no,directories=no, status=yes')
            // setLoading(false)
            //  console.log(link)
        }).catch(function (error) {
            console.log(error)
            UseAlertMessageLogin(400, getTranslationByKey(error.message))

            return error;
        });
    }

    async getChallengeRegionLeaderboard(challenge_id, filters) {
        return new Promise(async (resolve, reject) => {
            //axios.defaults.headers.common['Authorization'] = await getToken();
            axios.defaults.headers.common['Authorization'] = await getToken();
            axios.defaults.headers.common['Language'] = localStorage.getItem('language') ? localStorage.getItem('language') : 'en';
            //axios.get(getApiUrl() + '/v3/user').then(function (response) {

            axios.post(getApiUrl() + '/solidarity_challenge/challenge/' + challenge_id + '/leaderboard/region', filters).then((response) => {
                resolve(response.data)
            }).catch(function (error) {
                UseAlertMessageLogin(400, getTranslationByKey(error.message))
                reject(error);
            });
        });
    }
    async getTeamLeaderboard(challenge_id, filters) {
        return new Promise(async (resolve, reject) => {
            axios.defaults.headers.common['Authorization'] = await getToken();
            axios.defaults.headers.common['Language'] = localStorage.getItem('language') ? localStorage.getItem('language') : 'en';
            //axios.get(getApiUrl() + '/v3/user').then(function (response) {

            axios.post(getApiUrl() + '/solidarity_challenge/challenge/' + challenge_id + '/leaderboard/team', filters).then((response) => {
                resolve(response.data)
            }).catch(function (error) {
                UseAlertMessageLogin(400, getTranslationByKey(error.message))
                reject(error);
            });
        })
    }
    async getTeamById(challenge_id, team_id) {
        console.log(team_id)
        return new Promise(async (resolve, reject) => {
            axios.defaults.headers.common['Authorization'] = await getToken();
            axios.defaults.headers.common['Language'] = localStorage.getItem('language') ? localStorage.getItem('language') : 'en';
            //axios.get(getApiUrl() + '/v3/user').then(function (response) {
            axios.get(getApiUrl() + '/solidarity_challenge/challenge/' + challenge_id + '/team/' + team_id + '/members').then((response) => {
                resolve(response.data)
            }).catch(function (error) {
                UseAlertMessageLogin(400, getTranslationByKey(error.message))
                reject(error);
            });
        })
    }
    async createTeam(challenge_id, teamName) {
        return new Promise(async (resolve, reject) => {
            axios.defaults.headers.common['Authorization'] = await getToken();
            axios.defaults.headers.common['Language'] = localStorage.getItem('language') ? localStorage.getItem('language') : 'en';
            //axios.get(getApiUrl() + '/v3/user').then(function (response) {

            axios.post(getApiUrl() + '/solidarity_challenge/challenge/' + challenge_id + '/team/create', teamName).then((response) => {
                resolve(response.data)
                UseAlertMessageLogin(200, 'Team created!')
            }).catch(function (error) {
                UseAlertMessageLogin(400, getTranslationByKey(error.response.data.message))
                reject(error);
            });
        })
    }

}

export class ActivityService extends Component {

    //get activities
    async getActivities(challenge_id) {
        return new Promise(async (resolve, reject) => {
            axios.defaults.headers.common['Authorization'] = await getToken();
            axios.defaults.headers.common['Language'] = localStorage.getItem('language') ? localStorage.getItem('language') : 'en';

            axios.get(getApiUrl() + '/solidarity_challenge/' + challenge_id + '/activity').then((response) => {
                resolve(response.data)
            }).catch(function (error) {
                if (error.response.status == 401) {
                    UseAlert(401)
                }
                reject(error);
            });
        });
    }


}